import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [NgbPaginationModule, DropdownModule, FormsModule, TranslateModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() page = 1;
  @Input() pageSize = 10;
  @Input() totalRecords = 0;
  @Input() pageSizeOptions = [5, 10, 20];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.ceil(this.totalRecords / this.pageSize);
  }

  onPageChange(newPage: number) {
    this.pageChange.emit(newPage);
  }

  onPageSizeChange(event: DropdownChangeEvent) {
    this.pageSizeChange.emit(event.value);
  }
}
